<template>
  <div class="code-tabs">
    <div class="code-tabs__bar" role="tablist">
      <button
        v-for="sample in samples"
        :key="sample.id"
        type="button"
        role="tab"
        class="code-tabs__tab"
        :class="{ 'is-active': sample.id === activeId }"
        :aria-selected="sample.id === activeId"
        @click="activeId = sample.id"
      >
        {{ sample.label }}
      </button>
    </div>
    <copy-field v-if="active" :value="active.code" :label="active.label + ' example'" block></copy-field>
  </div>
</template>

<script>
  // 多语言示例代码切换（cURL / JavaScript / Python）
  import CopyField from "./CopyField";

  export default {
    name: "CodeTabs",
    components: { CopyField },
    props: {
      samples: { type: Array, default: () => [] }
    },
    data() {
      return { activeId: this.samples.length ? this.samples[0].id : "" };
    },
    computed: {
      active() {
        return this.samples.find(s => s.id === this.activeId) || this.samples[0];
      }
    }
  };
</script>

<style scoped lang="scss">
  .code-tabs__bar {
    display: flex;
    gap: 4px;
    margin-bottom: 8px;
  }

  .code-tabs__tab {
    border: 1px solid transparent;
    background: none;
    color: var(--vtm-ink-2);
    border-radius: var(--vtm-r-sm);
    padding: 4px 10px;
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;

    &:hover {
      color: var(--vtm-ink);
    }

    &.is-active {
      background: var(--vtm-mint-soft);
      color: var(--vtm-mint-ink);
    }

    &:focus-visible {
      outline: none;
      box-shadow: var(--vtm-focus-ring);
    }
  }
</style>
